function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { OpportunitiesApiService } from "./Services/OpportunitiesApiService";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { CommonBuilder } from "./Helpers/CommonBuilder";
import { FormManager } from "./Helpers/FormManager";
import { InnerPageBuilder } from "./Helpers/InnerPageBuilder";
import { UserService } from "./Services/UserService";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { CustomFormBuilder } from "./Helpers/CustomFormBuilder";
import { StringUtils } from "./Helpers/StringUtils";
import { Configuration } from "./Shared/Configuration";
export var MppOpportunityDetails = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppOpportunityDetails, _ComponentBase);

  var _super = _createSuper(MppOpportunityDetails);

  function MppOpportunityDetails() {
    var _this;

    _classCallCheck(this, MppOpportunityDetails);

    _this = _super.call(this);
    _this.userLoggedIn = false;
    return _this;
  }

  _createClass(MppOpportunityDetails, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$detailsContainer) {
        this.loadAttributes();
        this.LoadOpportunity();
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.showFullAddress = this.getAttribute("showfulladdress") || false;
      this.returnUrl = this.getAttribute("returnurl");
      this.responseEmailTemplate = this.getAttribute("responseemailtemplate") || "";
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this,
            _mppWidgetsConfigValu;

        var i18n, mppWidgetsConfigValues, responseForm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppOpportunityDetails.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this2._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this2._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n;
                this.loadAttributes();
                _context.next = 7;
                return new Configuration().GetGlobalConfigurationSettingValues();

              case 7:
                mppWidgetsConfigValues = _context.sent;
                this._opportunityDetailWidgetIdParameterName = (_mppWidgetsConfigValu = mppWidgetsConfigValues.opportunityDetailWidgetIdParameterName) !== null && _mppWidgetsConfigValu !== void 0 ? _mppWidgetsConfigValu : "id"; //attributes

                this.responseEmailTemplate = this.hasAttribute("responseemailtemplate") === false ? "" : this.getAttribute("responseemailtemplate");
                this._root.innerHTML +=  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div id="emptyContainer"><i class="mppw-spinner"></i></div><div id="mppw-component-container" class="mppw-component-container"><div id="resultMessageContainer" class="mppw-alert" style="display: none;"><div class="mppw-alert__icon"></div><span id="resultMessageText" class="mppw-alert__text"></span></div><div id="detailsContainer"></div><div class="mpp-innerpage--map-container"><div id="map" class="mpp-innerpage--map"></div><div id="mapAddress" class="mpp-innerpage--map-info"></div></div><h2 id="responseFormTitle">${i18n.responseFormTitle}</h2><form id="responseForm" class="mppw-form mppw-form-validate"><input type="hidden" name="UseEmailTemplate" value="${this.responseEmailTemplate || ''}"/> <input type="hidden" id="opportunityId" name="OpportunityId" value="${this._opportunityId || ''}"/><div id="opportunityRespondDiv"><div id="opportunityForm"><div id="userHasRespondedContainer"></div><div id="respondAsContainer" class="mppw-form-field mppw-form-field__static-container" style="display: none"><select name="ContactId" id="respondAs" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="respondAs">${i18n.respondAsLabel}*:</label></div><div id="blankForm" style="display: none"><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="FirstName" type="text" id="firstNameText" class="mppw-form-field__control" data-required-message="${i18n.firstNameRequired}" required/> <label class="mppw-form-field__label" for="">${i18n.firstNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="LastName" type="text" id="lastNameText" class="mppw-form-field__control" data-required-message="${i18n.lastNameRequired}" required/> <label class="mppw-form-field__label" for="">${i18n.lastNameLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="EmailAddress" type="email" id="emailText" class="mppw-form-field__control" data-required-message="${i18n.emailAddressRequired}" required data-require-if-blank="MobilePhoneNumber"/> <label class="mppw-form-field__label" for="">${i18n.emailLabel}*:</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input name="MobilePhoneNumber" type="tel" id="phoneText" class="mppw-form-field__control" data-required-message="${i18n.phoneNumberRequired}" required data-require-if-blank="EmailAddress"/> <label class="mppw-form-field__label" for="">${i18n.phoneNumberLabel}*:</label></div></div></div></div><div class="mppw-form-field" id="formMessage"><textarea id="messageText" name="Message" class="mppw-form-field__control mppw-form-field__control__textarea" maxlength="500" value=""></textarea> <label class="mppw-form-field__label" for="">${i18n.messageLabel}:</label><div class="mppw-textarea-counter"></div></div><div id="formFields"></div></div><div class="mppw-centered" id="submitOpportunity"><input id="responseButton" type="submit" class="mppw-btn primary" value="${i18n.responseButtonText}"/></div></div></form></div>` ;
                this._$detailsContainer = this._root.querySelector("#detailsContainer");
                this._$respondAs = this._root.querySelector("#respondAs");
                this._$respondAsContainer = this._root.querySelector("#respondAsContainer");
                this._$blankForm = this._root.querySelector("#blankForm");
                this._$formMessage = this._root.querySelector("#formMessage");
                this._$submitOpportunity = this._root.querySelector("#submitOpportunity");
                this._$responseForm = this._root.querySelector("#responseForm");
                this._$responseButton = this._root.querySelector('#responseButton');
                this._$userHasRespondedContainer = this._root.querySelector('#userHasRespondedContainer');
                this._$firstNameText = this._root.querySelector("#firstNameText");
                this._$lastNameText = this._root.querySelector("#lastNameText");
                this._$emailText = this._root.querySelector("#emailText");
                this._$phoneText = this._root.querySelector("#phoneText");
                this._$resultMessageContainer = this._root.querySelector("#resultMessageContainer");
                this._$resultMessageText = this._root.querySelector("#resultMessageText");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$map = this._root.querySelector("#map");
                this._$mapAddress = this._root.querySelector("#mapAddress");
                this._$componentContainer = this._root.querySelector("#mppw-component-container");
                this._$responseFormTitle = this._root.querySelector("#responseFormTitle");
                this._$formFields = this._root.querySelector("#formFields");
                this._$opportunityId = this._root.querySelector("#opportunityId");
                this._$opportunityForm = this._root.querySelector("#opportunityForm");
                this._userInfo = null;
                this._customFormGuid = null;
                this._allMembers = null;
                this._opportunityId = CommonBuilder.GetId(this._opportunityDetailWidgetIdParameterName);

                if (!this._opportunityId) {
                  this._opportunityId = CommonBuilder.GetId("id");
                }

                this._$opportunityId.value = this._opportunityId;
                this._$isSubmitting = false;
                _context.next = 43;
                return UserService.GetCurrentUser().then(function (userInfo) {
                  _this2._$respondAsContainer.style.display = "";

                  _this2.HideBlankForm();

                  _this2._userInfo = userInfo;

                  if (!!userInfo) {
                    _this2.userLoggedIn = true;
                  }

                  var householdService = new HouseholdApiService();
                  householdService.GetHouseholdMembers().then(function (members) {
                    if (!!members && members.length > 0) {
                      _this2._allMembers = members.map(function (member) {
                        return {
                          id: member.contactId,
                          value: member.displayName
                        };
                      }); //Load family member dropdown

                      DropdownBuilder.LoadDropdown(_this2._$respondAs, _this2._allMembers, "Blank Form");

                      _this2.SetSelectedRespondAsDropdown(_this2._userInfo.contactId); // Check if user has responded


                      _this2.UserHasResponded(i18n, _this2._userInfo.contactId);
                    }
                  });
                }, function () {
                  _this2._$respondAsContainer.style.display = "none";

                  _this2.ShowBlankForm();
                });

              case 43:
                _context.next = 45;
                return this.LoadOpportunity();

              case 45:
                this._$respondAs.addEventListener("change", function (e) {
                  _this2.UserHasResponded(i18n, e.target.value); //Only show blank form if drop down value is null


                  if (!!_this2._$respondAs.value) {
                    _this2.HideBlankForm();
                  } else {
                    _this2.ShowBlankForm();
                  }
                });

                responseForm = new FormManager(this._$responseForm);

                this._$responseForm.addEventListener("submit", function (event) {
                  event.preventDefault();

                  if (responseForm.IsValid()) {
                    if (_this2._$isSubmitting === true) {
                      return;
                    }

                    var formData = new FormData(_this2._$responseForm);

                    if (!formData.get("ContactId")) {
                      formData.set("ContactId", 0);
                    }

                    var opportunitiesService = new OpportunitiesApiService();
                    _this2._$isSubmitting = true;

                    var btn = _this2._$responseForm.querySelector("[type='submit']");

                    btn.disabled = true;
                    opportunitiesService.RespondToOpportunity(formData).then(function (data) {
                      var _this2$_userInfo;

                      var displayName;

                      if (_this2._allMembers && _this2._$respondAs.getAttribute("value") !== "") {
                        var member = _this2._allMembers.find(function (member) {
                          return member.id == Number(_this2._$respondAs.value);
                        });

                        displayName = member.value;
                      } else {
                        displayName = "".concat(_this2._$firstNameText.value, " ").concat(_this2._$lastNameText.value);
                      }

                      responseForm.Reset(); // Re-draw custom form

                      _this2.DrawCustomForm();

                      _this2.SetSelectedRespondAsDropdown((_this2$_userInfo = _this2._userInfo) === null || _this2$_userInfo === void 0 ? void 0 : _this2$_userInfo.contactId);

                      responseForm.ScrollToTop();

                      _this2.SetMessage("success", StringUtils.replaceStringTokens(i18n.thankYouMessage, {
                        "display_name": displayName
                      }));
                    })["catch"](function (error) {
                      console.error(error);

                      _this2.SetMessage("danger", i18n.responseFailedMessage + " \n" + error.error ? error.error : error);
                    })["finally"](function () {
                      _this2._$isSubmitting = false;
                      btn.disabled = false;
                    });
                  } else {
                    _this2.SetMessage("warning", i18n.validationFailedMessage);
                  }
                });

                this._$responseForm.addEventListener("reset", function (event) {
                  _this2._$responseButton.style.display = "";
                  _this2._$responseButton.type = 'submit';
                  _this2._$responseButton.value = _this2._i18n.responseButtonText;
                  _this2._$opportunityForm.style.display = "";
                  _this2._$resultMessageText.innerHTML = "";
                  _this2._$resultMessageContainer.style.display = "none";

                  _this2.ShowBlankForm();

                  _this2._$responseFormTitle.scrollIntoView({
                    behavior: 'smooth'
                  });
                });

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "DrawCustomForm",
    value: function () {
      var _DrawCustomForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return CustomFormBuilder.RenderCustomForm(this._customFormGuid, this._$formFields, this._$responseForm, false, !!this._userInfo);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function DrawCustomForm() {
        return _DrawCustomForm.apply(this, arguments);
      }

      return DrawCustomForm;
    }()
  }, {
    key: "SetSelectedRespondAsDropdown",
    value: function SetSelectedRespondAsDropdown(contactId) {
      if (!!contactId) {
        // Set dropdown selected
        this._$respondAs.value = contactId;
      }
    }
  }, {
    key: "LoadOpportunity",
    value: function () {
      var _LoadOpportunity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var opportunitiesService, opportunityData, _meetingDayText, detailsContainerHTML, imageUrl, title, meetingDay, description, startDate, remainingNeeded, contacts, location, latitude, longitude, address, customFormGuid, forceLogin, meetingDayText;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                opportunitiesService = new OpportunitiesApiService(); // Hide certain elements before data is loaded

                this.HideElementsBeforeLoad();
                _context3.prev = 2;
                _context3.next = 5;
                return opportunitiesService.GetOpportunityDetail(this._opportunityId);

              case 5:
                opportunityData = _context3.sent;

                if (!opportunityData) {
                  _context3.next = 23;
                  break;
                }

                this._$detailsContainer.innerHTML = "";
                this._$emptyContainer.innerHTML = "";
                detailsContainerHTML = "";
                imageUrl = opportunityData.imageUrl, title = opportunityData.title, meetingDay = opportunityData.meetingDay, description = opportunityData.description, startDate = opportunityData.startDate, remainingNeeded = opportunityData.remainingNeeded, contacts = opportunityData.contacts, location = opportunityData.location, latitude = opportunityData.latitude, longitude = opportunityData.longitude, address = opportunityData.address, customFormGuid = opportunityData.customFormGuid, forceLogin = opportunityData.forceLogin;
                this._customFormGuid = customFormGuid;
                this._opportunityData = opportunityData;
                meetingDayText = meetingDay;

                if (((_meetingDayText = meetingDayText) === null || _meetingDayText === void 0 ? void 0 : _meetingDayText.toLowerCase()) === "ongoing" && this._i18n.ongoingLabel) {
                  meetingDayText = this._i18n.ongoingLabel;
                }

                detailsContainerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(this._i18n.backToResultsHeader, this.returnUrl, ReturnContext.Categories.Opportunities), InnerPageBuilder.BuildFinderDetailImage(imageUrl, 'opportunity'), InnerPageBuilder.BuildTitle(title), InnerPageBuilder.BuildOpportunityDateTime(startDate, meetingDayText), InnerPageBuilder.BuildDescription(description), InnerPageBuilder.BuildSpecialText(this._i18n.remainingNeedLabel, remainingNeeded, this._i18n.remainingNeedCounterTextLabel), InnerPageBuilder.BuildContacts(contacts, this._i18n.primaryContactLabel));

                if (latitude === null && longitude === null && !!location) {
                  detailsContainerHTML += InnerPageBuilder.BuildSpecialText(this._i18n.LocationLabel, location);
                } else {
                  this._$map.style.display = "";
                  this._$mapAddress.style.display = "";
                  this._$mapContainer.style.display = "block";
                  this._$map.innerHTML = InnerPageBuilder.BuildGoogleMap(this._$map, latitude, longitude, address, title);
                  this._$mapAddress.innerHTML = InnerPageBuilder.BuildMapAddress(address);
                }

                this._$detailsContainer.innerHTML += detailsContainerHTML; // Display response form if remainingNeeded is null or greater than 0

                if (remainingNeeded === null || remainingNeeded === undefined || remainingNeeded === '' || remainingNeeded > 0) {
                  this._$responseForm.style.display = "";
                } else {
                  // Hide response form and display message that maximum number has been met
                  this._$responseForm.style.display = "none";
                  this.SetMessage("warning", this._i18n.maximumNumberRegistered);
                } // Display custom form if any


                _context3.next = 21;
                return this.DrawCustomForm();

              case 21:
                if (forceLogin !== null && forceLogin === true && this.userLoggedIn === false) {
                  this.HideBlankForm();
                  this._$formMessage.style.display = "none";
                  this._$submitOpportunity.style.display = "none";
                } else {
                  this._$formMessage.style.display = "";
                  this._$submitOpportunity.style.display = "";
                } // Show elements


                this.ShowElementsAfterLoad();

              case 23:
                _context3.next = 33;
                break;

              case 25:
                _context3.prev = 25;
                _context3.t0 = _context3["catch"](2);
                console.error(_context3.t0);
                this._$detailsContainer.style.display = "block";
                this._$detailsContainer.innerHTML += InnerPageBuilder.BuildInnerPageDetails(InnerPageBuilder.BuildGoBack(this._i18n.backToResultsHeader, this.returnUrl, ReturnContext.Categories.Opportunities));
                this._$emptyContainer.innerHTML = "";
                this._$userHasRespondedContainer.innerHTML = '';
                this.SetMessage("danger", this._i18n.noOpportunityFound);

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 25]]);
      }));

      function LoadOpportunity() {
        return _LoadOpportunity.apply(this, arguments);
      }

      return LoadOpportunity;
    }()
  }, {
    key: "HideElementsBeforeLoad",
    value: function HideElementsBeforeLoad() {
      this._$detailsContainer.style.display = "none";
      this._$responseFormTitle.style.display = "none";
      this._$responseForm.style.display = "none";
    }
  }, {
    key: "ShowElementsAfterLoad",
    value: function ShowElementsAfterLoad() {
      this._$responseFormTitle.style.display = "block";
      this._$detailsContainer.style.display = "block";
    }
  }, {
    key: "UserHasResponded",
    value: function UserHasResponded(i18n, contactId) {
      var _this3 = this;

      var opportunitiesService = new OpportunitiesApiService();
      opportunitiesService.HasResponded(this._opportunityId, contactId).then(function (respondedResponse) {
        if (respondedResponse) {
          _this3._$userHasRespondedContainer.innerHTML = "<div class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.youHaveAlreadyRespondedMessage, "</span>\n\t\t\t\t\t</div>");
        } else {
          _this3._$userHasRespondedContainer.innerHTML = '';
        }
      })["catch"](function (error) {
        console.error(error);
        _this3._$userHasRespondedContainer.innerHTML = '';

        _this3.SetMessage("danger", i18n.respondAsFailedMessage + " \n" + error);
      });
    }
  }, {
    key: "ShowBlankForm",
    value: function ShowBlankForm() {
      this._$blankForm.style.display = "";

      this._$firstNameText.setAttribute("required", true);

      this._$lastNameText.setAttribute("required", true);

      this._$emailText.setAttribute("required", true);

      this._$phoneText.setAttribute("required", true);
    }
  }, {
    key: "HideBlankForm",
    value: function HideBlankForm() {
      this._$blankForm.style.display = "none";

      this._$firstNameText.removeAttribute("required");

      this._$lastNameText.removeAttribute("required");

      this._$emailText.removeAttribute("required");

      this._$phoneText.removeAttribute("required");
    }
  }, {
    key: "SetMessage",
    value: function SetMessage(status, message) {
      var _this4 = this;

      this._$resultMessageContainer.classList.remove("mppw-alert__success");

      this._$resultMessageContainer.classList.remove("mppw-alert__info");

      this._$resultMessageContainer.classList.remove("mppw-alert__warning");

      this._$resultMessageContainer.classList.remove("mppw-alert__danger");

      this._$resultMessageContainer.classList.add("mppw-alert__".concat(status));

      this._$resultMessageText.innerHTML = message;
      this._$resultMessageContainer.style.display = "";

      if (status === "success") {
        this.HideBlankForm();
        this._$opportunityForm.style.display = "none";
        this._$responseButton.value = this._i18n.additionalResponseButtonText;
        this._$responseButton.type = 'reset';
      } else if (status === "danger") {
        this._$responseButton.style.display = "none";
        this._$responseForm.style.display = "";
        this._$opportunityForm.style.display = "none";
        this._$resultMessageContainer.style.display = "block";
      } else {
        setTimeout(function () {
          _this4._$resultMessageText.innerHTML = "";
          _this4._$resultMessageContainer.style.display = "none";
        }, 10000);
      }
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Opportunity Details",
        tag: "mpp-opportunity-details",
        configurationItems: [{
          name: "Return URL",
          attribute: "returnurl",
          description: "URL that defines the path back to the Opportunity Finder. It can be a relative or fully qualified URL.",
          required: true,
          type: "url"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["showfulladdress", "returnurl", "responseemailtemplate"];
    }
  }]);

  return MppOpportunityDetails;
}(ComponentBase);
MppOpportunityDetails.registerComponent(MppOpportunityDetails.WidgetDetails.tag, MppOpportunityDetails);